import { apiGet } from "./apiClient";

// The single most cross-domain-reused fetch in the feature — the same GET,
// independently re-implemented in WorkflowTaskDrawer, CancelModal,
// EditDraftDrawer, SendToSuppliersModal, PaymentLinkModal,
// QuoteApprovalModal, and PriceUpdateDrawer (7 files spanning board,
// workflow-drawer, drafts, suppliers, payments, quotes, and price-drawer).
// The authenticated token is the only actor identity. Ownership and
// cross-owner visibility are enforced by the backend permission layer.
export function fetchTaskDetail(queryPk) {
  const qs = new URLSearchParams({ query_pk: queryPk });
  return apiGet(`/query_workflow/task/get?${qs}`)
    .then(res => (res.data?.success ? res.data.data : null))
    .catch(() => null);
}
